module.exports = __webpack_public_path__ + "images/d57ea3b9149762a6668d777ece5bdee7.Calendar.png";